// Thin progress bar for a single metered resource. Width is the consumed percent (clamped
// 0–100 so an over-cap tenant fills the track rather than overflowing); color reflects status.
export default function UsageBar({ percent, color }: { percent: number; color: string }) {
  const width = Math.min(100, Math.max(0, percent));
  return (
    <div
      role="progressbar"
      aria-valuenow={Math.round(percent)}
      aria-valuemin={0}
      aria-valuemax={100}
      style={{
        height: 6,
        background: 'var(--line)',
        borderRadius: 999,
        overflow: 'hidden',
      }}
    >
      <div style={{ height: '100%', width: `${width}%`, background: color }} />
    </div>
  );
}
